import { type ReactNode } from 'react';

import { MaintenanceScreen } from '@/features/home/components/MaintenanceScreen';
import { useBooth } from '@/features/settings/hooks/useBooth';

interface MaintenanceGuardProps {
  children: ReactNode;
}

/**
 * If maintenance mode is active (globally or for this booth), block all routes
 * and show the maintenance screen. The user cannot dismiss it.
 * Only the admin can deactivate the flag in the back-office.
 */
export function MaintenanceGuard({ children }: MaintenanceGuardProps) {
  const { isMaintenanceModeEnabled } = useBooth();

  if (isMaintenanceModeEnabled) {
    return <MaintenanceScreen />;
  }

  return <>{children}</>;
}
